import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NuevoDocumentoModule } from '../MatrizDocumentos/nuevo-documento/nuevo-documento.module';
import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'general',
        loadChildren: () => import('../prozess-general/prozess-general.module').then(m => m.ProzessGeneralModule)
      }, {
        path: 'contingencias',
        loadChildren: () => import('../informes/contingencias/contingencias.module').then(m => m.ContingenciasModule)
      }, {
        path: 'comite-auditoria',
        loadChildren: () => import('../informes/comite-auditoria/comite-auditoria.module').then(m => m.ComiteAuditoriaModule)
      }, {
        path: 'honorarios',
        loadChildren: () => import('../informes/honorarios/honorarios.module').then(m => m.HonorariosModule)
      }, {
        path: 'inventario-procesos',
        loadChildren: () => import('../informes/inventario-procesos/inventario-procesos.module').then(m => m.InventarioProcesosModule)
      }, {
        path: 'procesos-fogafin',
        loadChildren: () => import('../informes/procesos-fogafin/procesos-fogafin.module').then(m => m.ProcesosFOGAFINModule)
      }, {
        path: 'calificadora',
        loadChildren: () => import('../informes/calificadora/calificadora.module').then(m => m.CalificadoraModule)
      }, {
        path: 'notas-estado-financiero',
        loadChildren: () => import('../informes/notas-estado-financiero/notas-estado-financiero.module').then(m => m.NotasEstadoFinancieroModule)
      }, {
        path: 'embargos',
        loadChildren: () => import('../informes/embargos/embargos.module').then(m => m.EmbargosModule)
      }, {
        path: 'deposito-judicial',
        loadChildren: () => import('../informes/deposito-judicial/deposito-judicial.module').then(m => m.DepositoJudicialModule)
      }, {
        path: 'pagos',
        loadChildren: () => import('../informes/pagos/pagos.module').then(m => m.PagosModule)
      }, {
        path: 'tutela',
        loadChildren: () => import('../informes/tutela/tutela.module').then(m => m.TutelaModule)
      }, {
        path: 'reasignacion',
        loadChildren: () => import('../estructura-caso/reasignacion/reasignacion.module').then(m => m.ReasigancionModule)
      }, {
        path: 'relacion-procesos-penales',
        loadChildren: () => import('../informes/relacion-procesos-penales/relacion-procesos-penales.module').then(m => m.RelacionProcesosPenalesModule)
      }, {
        path: 'general-casos',
        loadChildren: () => import('../consulta/general-casos/general-casos.module').then(m => m.GeneralCasosModule)
      }, {
        path: 'evolutivo-casos',
        loadChildren: () => import('../consulta/evolutivo-casos/evolutivo-casos.module').then(m => m.EvolutivoCasosModule)
      }, {
        path: 'analisis-de-riesgos',
        loadChildren: () => import('../analisis-de-riesgos/analisis-de-riesgos.module').then(m => m.AnalisisDeRiesgosModule)
      }, {
        path: 'procesos',
        loadChildren: () => import('../consulta/procesos/procesos.module').then(m => m.ProcesosModule)
      }, {
        path: 'insertar-gastos',
        loadChildren: () => import('../gestion-Financiera/insertar-gastos/insertar-gastos.module').then(m => m.InsertarGastosModule)
      }, {
        path: 'actualizar-informacion-gastos',
        loadChildren: () => import('../gestion-Financiera/actualizar-informacion-gastos/actualizar-informacion-gastos.module').then(m => m.ActualizarInformacionGastosModule)
      }, {
        path: 'actualizar-documento-cobro',
        loadChildren: () => import('../gestion-Financiera/actualizar-documento-cobro/actualizar-documento-cobro.module').then(m => m.ActualizarDocumentoCobroModule)
      }, {
        path: 'cambiar-estado-gastos',
        loadChildren: () => import('../gestion-Financiera/cambiar-estado-gastos/cambiar-estado-gastos.module').then(m => m.CambiarEstadoGastosModule)
      }, {
        path: 'inactivar-gastos',
        loadChildren: () => import('../gestion-Financiera/inactivar-gastos/inactivar-gastos.module').then(m => m.InactivarGastosModule)
      }, {
        path: 'asistente-creacion-proceso',
        loadChildren: () => import('../estructura-caso/asistente-creacion-proceso/asistente-creacion-proceso.module').then(m => m.AsistenteCreacionProcesoModule)
      }, {
        path: 'gestion-pruebas',
        loadChildren: () => import('../estructura-caso/gestion-pruebas/gestion-pruebas.module').then(m => m.GestionPruebasModule)
      }, {
        path: 'activacion-inactivacion-plataforma',
        loadChildren: () => import('../procedimientos/activacion-inactivacion-plataforma/activacion-inactivacion-plataforma.module').then(m => m.ActivacionInactivacionPlataformaModule)
      }, {
        path: 'gestion-hechos',
        loadChildren: () => import('../estructura-caso/gestion-hechos/gestion-hechos.module').then(m => m.GestionHechosModule)
      }, {
        path: 'gestion-delitos',
        loadChildren: () => import('../estructura-caso/gestion-delitos/gestion-delitos.module').then(m => m.GestionDelitosModule)
      }, {
        path: 'fiduciaria-cierre-contable',
        loadChildren: () => import('../informes/fiduciaria-cierre-contable/fiduciaria-cierre-contable.module').then(m => m.FiduciariaCierreContableModule)
      }, {
        path: 'fiduciaria-informe-trimestral-litigios',
        loadChildren: () => import('../informes/fiduciaria-informe-trimestral-litigios/fiduciaria-informe-trimestral-litigios.module').then(m => m.FiduciariaInformeTrimestralLitigiosModule)
      }, {
        path: 'informe-contable-gastos',
        loadChildren: () => import('../informes/Informe-contable-gastos/Informe-contable-gastos.module').then(m => m.InformeContableGastosModule)
      }, {
        path: 'comparativo-de-provision',
        loadChildren: () => import('../informes/comparativo-de-provision/comparativo-de-provision.module').then(m => m.ComparativoDeProvisionModule)
      }, {
        path: 'respuesta-hecho-cumplido',
        loadChildren: () => import('../procedimientos/tutelas/respuesta-hecho-cumplido/respuesta-hecho-cumplido.module').then(m => m.RespuestaHechoCumplidoModule)
      }, {
        path: 'terminacion-proceso',
        loadChildren: () => import('../estructura-caso/terminacion-proceso/terminacion-proceso.module').then(m => m.TerminacionProcesoModule)
      }, {
        path: 'consulta-requerimiento-externo',
        loadChildren: () => import('../requerimiento-externo/Consulta/requerimiento-externo.module').then(m => m.RequerimientoExternoModule)
      }, {
        path: 'informe-requerimiento-externo',
        loadChildren: () => import('../requerimiento-externo/Informe/Informe-requerimiento-externo.module').then(m => m.InformeRequerimientoExternoModule)
      }, {
        path: 'asignacion-requerimiento-externo',
        loadChildren: () => import('../requerimiento-externo/Asignacion/asignacion-requerimiento-externo.module').then(m => m.AsignacionRequerimientoExternoModule)
      }, {
        path: 'confirmar-asignacion',
        loadChildren: () => import('../requerimiento-externo/confirmar-asignacion/confirmar-asignacion.module').then(m => m.ConfirmarAsignacionModule)
      }, {
        path: 'cambiar-estado',
        loadChildren: () => import('../requerimiento-externo/Cambiar-Estado/Cambiar-Estado.module').then(m => m.CambiarEstadoModule)
      }, {
        path: 'inventario-procesos-fogafin',
        loadChildren: () => import('../informes/inventario-procesos-fogafin/inventario-procesos-fogafin.module').then(m => m.InventarioProcesosFogafinModule)
      }, {
        path: 'gestion-usuario',
        loadChildren: () => import('../requerimiento-externo/Gestion-de-usuario/gestion-usuario.module').then(m => m.GestionUsuarioModule)
      }, {
        path: 'acciones-proteccion-consumidor',
        loadChildren: () => import('../informes/acciones-proteccion-consumidor/acciones-proteccion-consumidor.module').then(m => m.AccionesProteccionConsumidorModule)
      }, {
        path: 'estadistica-proceso',
        loadChildren: () => import('../informes/estadistica-proceso/estadistica-proceso.module').then(m => m.EstadisticaProcesoModule)
      }, {
        path: 'asistente-creacion-proceso-dos',
        loadChildren: () => import('../estructura-caso/asistente-creacion-proceso-dos/asistente-creacion-proceso-dos.module').then(m => m.AsistenteCreacionProcesoDosModule)
      }, {
        path: 'nuevo-documento',
        loadChildren: () => import('../MatrizDocumentos/nuevo-documento/nuevo-documento.module').then(m => NuevoDocumentoModule)
      }, {
        path: 'Creacion-Caso-Lite-Asignacion',
        loadChildren: () => import('../estructura-caso/creacion-caso-lite-asignacion/creacion-caso-lite-asignacion.module').then(m => m.CreacionCasoLiteAsignacionModule)
      }, {
        path: 'informe-superfinanciera-circular-0022013',
        loadChildren: () => import('../informes/informe-superfinanciera-circular-0022013/informe-superfinanciera-circular-0022013.module').then(m => m.InformeSuperfinancieraCircular0022013Module)
      }, {
        path: 'gastosPorUsuario',
        loadChildren: () => import('../gestion-Financiera/gastos-por-usuario/gastos-por-usuario.module').then(m => m.GastosPorUsuarioModule)
      }, {
        path: 'gestionContratos',
        loadChildren: () => import('../gestion-contratos/gestion-contratos.module').then(m => m.GestionContratosModule) // Este esta pendiente por crearse en al base de datos para su despliegue
      }, {
        path: 'actuaciones',
        loadChildren: () => import('../proceso/eventos-procesales/eventos-procesales.module').then(m => m.EventosProcesalesModule)
      }, {
        path: 'crear-bienes',
        loadChildren: () => import('../gestion-Financiera/bienes/inventario-bienes/crear-bienes/crear-bienes.module').then(m => m.CrearBienesModule)
      }, {
        path: 'buscar-bien',
        loadChildren: () => import('../gestion-Financiera/bienes/inventario-bienes/buscar-bien/buscar-bien.module').then(m => m.BuscarBienModule)
      }, {
        path: 'crear-lista-distribucion',
        loadChildren: () => import('../Seguimiento/lista-de-distribucion/crear-lista-de-distribucion/crear-lista-de-distribucion.module').then(m => m.CrearListaDeDistribucionModule)
      }, {
        path: 'consultar-lista-distribucion',
        loadChildren: () => import('../Seguimiento/lista-de-distribucion/consultar-lista-de-distribucion/consultar-lista-de-distribucion.module').then(m => m.ConsultarListaDeDistribucionModule)
      }, {
        path: 'editar-bien',
        loadChildren: () => import('../gestion-Financiera/bienes/inventario-bienes/editar-bien/editar-bien.module').then(m => m.EditarBienModule)
      }, {
        path: 'eliminar-bien',
        loadChildren: () => import('../gestion-Financiera/bienes/inventario-bienes/eliminar-bien/eliminar-bien.module').then(m => m.EliminarBienModule)
      }, {
        path: 'inactivar-lista-distribucion',
        loadChildren: () => import('../Seguimiento/lista-de-distribucion/inactivar-lista-de-distribucion/inactivar-lista-de-distribucion.module').then(m => m.InactivarListaDeDistribucionModule)
      }, {
        path: 'modificar-lista-distribucion',
        loadChildren: () => import('../Seguimiento/lista-de-distribucion/modificar-lista-de-distribucion/modificar-lista-de-distribucion.module').then(m => m.ModificarListaDeDistribucionModule)
      }, {
        path: 'asignacion-procesos-bienes',
        loadChildren: () => import('../estructura-caso/proceso/asignacion-procesos-bienes/asignacion-procesos-bienes.module').then(m => m.AsignacionProcesosBienesModule)
      }, {
        path: 'nuevo-contrato',
        loadChildren: () => import('../contratos/crear-contrato/crear-contrato.module').then(m => m.CrearContratoModule)
      }, {
        path: 'consultar-contrato',
        loadChildren: () => import('../contratos/consulta-contrato/consulta-contrato.module').then(m => m.ConsultaContratoModule)
      }, {
        path: 'editar-contrato',
        loadChildren: () => import('../contratos/editar-contrato/editar-contrato.module').then(m => m.EditarContratoModule)
      }, {
        path: 'eliminar-contrato',
        loadChildren: () => import('../contratos/eliminar-contrato/eliminar-contrato/eliminar-contrato.module').then(m => m.EliminarContratoModule)
      }, {
        path: 'inventario-contrato1',
        loadChildren: () => import('../contratos/informe-contratos/informe-contratos.module').then(m => m.InformeContratosModule)
      }, {
        path: 'cargue-contratos',//queda pendiente agregar a DDBB
        loadChildren: () => import('../contratos/cargue-contratos/cargue-contratos.module').then(m => m.CargueContratosModule)
      }, {
        path: 'gestion-pretensiones',
        loadChildren: () => import('../estructura-caso/pretensiones/crear-pretension/crear-pretension.module').then(m => m.CrearPretensionModule)
      }, {
        path: 'forzar-cambio-contrasena',
        loadChildren: () => import('../administrar-usuario/forzar-cambio-contrasena/forzar-cambio-contrasena.module').then(m => m.ForzarCambioContrasenaModule)
      }, {
        path: 'autogestioncontrasena',
        loadChildren: () => import('../auto-gestion/update-password/update-password.module').then(m => m.UpdatePasswordModule)
      }, {
        path: 'informe-de-usuarios',
        loadChildren: () => import('../administrar-usuario/informe-usuarios/informe-usuarios.module').then(m => m.InformeUsuariosModule)
      }, {
        path: 'matriz-litigios',
        loadChildren: () => import('../informes/informe-matriz-de-litigios/informe-matriz-de-litigios.module').then(m => m.InformeMatrizDeLitigiosModule)
      }, {
        path: 'informe-movimientos-relevantes',
        loadChildren: () => import('../informes/informe-movimientos-relevantes/informe-movimientos-relevantes.module').then(m => m.InformeMovimientosRelevantesModule)
      }, {
        path: 'informe-uair',
        loadChildren: () => import('../informes/informe-uair/informe-uair.module').then(m => m.InformeUairModule)
      }, {
        path: 'gestion-usuarios',
        loadChildren: () => import('../administrar-usuario/gestionar-usuario/gestionar-usuario.module').then(m => m.GestionarUsuarioModule)
      }, {
        path: 'informe-hechos',
        loadChildren: () => import('../informes/informe-hechos/informe-hechos.module').then(m => m.InformeHechosModule)
      }, {
        path: 'informe-rmc',
        loadChildren: () => import('../informes/informe-rmc/informe-rmc.module').then(m => m.InformeRmcModule)
      }, {
        path: 'informe-auditoria',
        loadChildren: () => import('../informes/informe-auditoria/informe-auditoria.module').then(m => m.InformeAuditoriaModule)
      }, {
        path: 'informe-casos-en-contra',
        loadChildren: () => import('../informes/informe-casos-en-contra/informe-casos-en-contra.module').then(m => m.InformeCasosEnContraModule)
      }, {
        path: 'informe-dashboard',
        loadChildren: () => import('../informes/informe-dashboard/informe-dashboard.module').then(m => m.InformeDashboardModule)
      }, {
        path: 'gestion-audiencias',
        loadChildren: () => import('../audiencias-diligencias/gestion-audiencias/gestion-audiencias.module').then(m => m.GestionAudienciasModule)
      }, {
        path: 'edicion-audienciasdiligencias',
        loadChildren: () => import('../audiencias-diligencias/editar-audiencias-diligencias/editar-audiencias-diligencias.module').then(m => m.EditarAudienciasDiligenciasModule)
      }, {
        path: 'buscar-tareas',
        loadChildren: () => import('../Seguimiento/Tarea/buscar-tarea/buscar-tarea.module').then(m => m.BuscarTareaModule)
      }, {
        path: 'crear-tareas',
        loadChildren: () => import('../Seguimiento/Tarea/crear-tarea/crear-tarea.module').then(m => m.CrearTareaModule)
      }, {
        path: 'asistente-creacion-tutelas',
        loadChildren: () => import('../estructura-caso/asistente-creacion-tutela/asistente-creacion-tutela.module').then(m => m.AsistenteCreacionTutelaModule)
      }, {
        path: 'gestionar-comentarios-casos',
        loadChildren: () => import('../estructura-caso/gestion-comentarios/gestion-comentarios-caso/gestion-comentarios-caso.module').then(m => m.GestionComentariosCasoModule)
      }, {
        path: 'generacion-planilla-gastos',
        loadChildren: () => import('../gestion-Financiera/generar-planilla-gastos/generar-planilla-gastos.module').then(m => m.GenerarPlanillaGastosModule)
      }, {
        path: 'gestionar-despachos',
        loadChildren: () => import('../fuentes-de-derecho/gestionar-despachos/gestion-despachos/gestion-despachos.module').then(m => m.GestionDespachosModule)
      }, {
        path: 'gestion-documentos-caso',
        loadChildren: () => import('../estructura-caso/gestion-documentos-caso-proceso/documentos-caso/documentos-caso.module').then(m => m.DocumentosCasoModule)
      }, {
        path: 'gestion-documentos-procesos',
        loadChildren: () => import('../estructura-caso/gestion-documentos-caso-proceso/documentos-proceso/documentos-proceso.module').then(m => m.DocumentosProcesoModule)
      }, {
        path: 'registro-presupuesto-proceso',
        loadChildren: () => import('../gestion-Financiera/registroPresupuestoProceso/registro-presupuesto-proceso/registro-presupuesto-proceso.module').then(m => m.RegistroPresupuestoProcesoModule)
      }, {
        path: 'informe-presupuesto-proceso',
        loadChildren: () => import('../gestion-Financiera/registroPresupuestoProceso/informe-presupuesto-proceso/informe-presupuesto-proceso.module').then(m => m.InformePresupuestoProcesoModule)
      }, {
        path: 'informe-audiencias-diligencias',
        loadChildren: () => import('../audiencias-diligencias/informe-audiencias-diligencias/informe-audiencias-diligencias.module').then(m => m.InformeAudienciasDiligenciasModule)
      }, {
        path: 'gestion-origenes-litigios',
        loadChildren: () => import('../estructura-caso/asistente-creacion-proceso-dos/origen-litigio/origen-litigio.module').then(m => m.OrigenLitigioModule)
      }, {
        path: 'informe-gastos',
        loadChildren: () => import('../informes/informe-gastos/informe-gastos.module').then(m => m.InformeGastosModule)
      }, {
        path: 'informe-procesos-estados',
        loadChildren: () => import('../informes/informe-procesos-por-estado/informe-procesos-por-estado.module').then(m => m.InformeProcesosPorEstadoModule)
      }, {
        path: 'informe-bienes',
        loadChildren: () => import('../informes/informe-bienes/informe-bienes.module').then(m => m.InformeBienesModule)
      }, {
        path: 'informe-mis-procesos',
        loadChildren: () => import('../informes/mis-procesos/mis-procesos.module').then(m => m.MisProcesosModule)
      }
    ]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
